import { useTranslation } from 'react-i18next';
import { EApiType, EDataTableType, EModuleType } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { getNotifications, retriggerNotification } from '../../../store/states/NotificationSlice';
import { useDispatch } from 'react-redux';
import { AppStore } from '../../../store/AppStore';
import { useApiError } from '../../../hooks';
import { joinSelectedKeys } from '../../../services/DataHelperFunctions';
import { NotificationApi } from '../../../api/NotificationApi';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { formatLogContent } from '../../Helper/DataTableHelper';

import type { IManagementProps } from '../../../../types';
import type { IDeleteRequest } from '../../../../types/IApiTypes';

export const NotificationManagement = (props: IManagementProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.NotificationKey);

  /**
   * This method trigger when user click on the delete button on the data table
   * This method calls the delete notification api to delete the selected notification rows
   * @param {string [] } request the selected row id list
   * @returns {void}
   */
  const deleteItems = async (request: IDeleteRequest): Promise<void> => {
    const notificationData = AppStore.getState().notifications;
    const delKeys = joinSelectedKeys(request);

    const response = await NotificationApi.deleteNotification({ request });
    if (response?.data) {
      const message = t('messages.success.delete.notification', {
        length: request.length,
        list: delKeys,
      });
      dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
      dispatch(
        getNotifications({
          page: notificationData.currentPage,
          limit: notificationData.recordsPerPage,
          searchCode: notificationData.searchKey,
        })
      );
    } else {
      const message = t('messages.fail.delete.notification', {
        length: delKeys.length,
        list: delKeys,
      });
      dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
    }
  };

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('labels.notificationManagement')}</h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.Ace}
        getDataList={getNotifications}
        moduleType={EModuleType.Notifications}
        deleteItems={deleteItems}
        retrigger={retriggerNotification}
        getLogContent={formatLogContent}
      />
    </>
  );
};
